import { render, staticRenderFns } from "./PosEditPromotionNew.vue?vue&type=template&id=57c9dc9f&scoped=true&"
import script from "./PosEditPromotionNew.vue?vue&type=script&lang=js&"
export * from "./PosEditPromotionNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c9dc9f",
  null
  
)

export default component.exports